import { render } from "./ErrorText.vue?vue&type=template&id=48ad4cf8&ts=true"
import script from "./ErrorText.vue?vue&type=script&lang=ts"
export * from "./ErrorText.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__